import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { action } from './action';
import { alert } from './alert';
import { avatar } from './avatar';
import { background } from './background';
import { badge } from './badge';
import { border } from './border';
import { button } from './button';
import { checkbox } from './checkbox';
import { chip } from './chip';
import { blue, green, grey, orange, red } from './colors';
import { ChronosphereColor } from './colors/types';
import { error } from './error';
import { events } from './events';
import { greyOption } from './grey';
import { illustration } from './illustration';
import { info } from './info';
import { input } from './input';
import { interactive } from './interactive';
import { menu } from './menu';
import { primary } from './primary';
import { radio } from './radio';
import { secondary } from './secondary';
import { status } from './status';
import { success } from './success';
import { switchPalette } from './switch';
import { syntaxHighlighting } from './syntax-highlighting';
import { table } from './table';
import { text } from './text';
import { warning } from './warning';

const fillerColor: ChronosphereColor = {
  50: '#FF00FF',
  100: '#FF00FF',
  150: '#FF00FF',
  200: '#FF00FF',
  300: '#FF00FF',
  400: '#FF00FF',
  500: '#FF00FF',
  600: '#FF00FF',
  700: '#FF00FF',
  800: '#FF00FF',
  850: '#FF00FF',
  900: '#FF00FF',
  950: '#FF00FF',
};

/**
 * Returns the MUI PaletteOptions for the given mode.
 */
export function getPaletteOptions(mode: PaletteMode, opts: GetThemeOptions): PaletteOptions {
  // Palette options should be split out into their own files with functions
  // for creating the option values based on light/dark mode
  return {
    mode,
    primary: primary(mode, opts),
    secondary: secondary(mode, opts),
    grey: opts.panwRebrandStubYear ? fillerColor : greyOption(mode, opts),
    background: background(mode, opts),
    action: action(mode, opts),
    text: text(mode, opts),
    error: error(mode, opts),
    warning: warning(mode, opts),
    info: info(mode, opts),
    success: success(mode, opts),
    interactive: interactive(mode, opts),

    // Component colors
    avatar: avatar(mode, opts),
    button: button(mode, opts),
    input: input(mode, opts),
    checkbox: checkbox(mode, opts),
    radio: radio(mode, opts),
    switch: switchPalette(mode, opts),
    chip: chip(mode, opts),
    alert: alert(mode, opts),
    badge: badge(mode, opts),
    menu: menu(mode, opts),
    table: table(mode, opts),

    // Custom colors
    designSystem: opts.panwRebrandStubYear
      ? {
          blue: fillerColor,
          green: fillerColor,
          grey: fillerColor,
          orange: fillerColor,
          red: fillerColor,
        }
      : {
          blue,
          green,
          grey,
          orange,
          red,
        },
    status: status(mode, opts),
    border: border(mode, opts),
    syntaxHighlighting: syntaxHighlighting(mode, opts),
    illustration: illustration(mode, opts),
    events: events(mode, opts),

    // A contrast threshold of 4.5:1 is required to meet AA
    // https://mui.com/material-ui/customization/palette/#accessibility
    contrastThreshold: 4.5,
  };
}
